import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b3d0aa2c")

_pushScopeId("data-v-b3d0aa2c")
const _hoisted_1 = { class: "fridgedoormonitor-daily" }
const _hoisted_2 = {
  key: 0,
  class: "fridgedoormonitor-daily-selectday"
}
const _hoisted_3 = {
  key: 1,
  class: "fridgedoormonitor-daily-content"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsSelectDateBar = _resolveComponent("FridgeDetailsSelectDateBar")
  const _component_FridgeDoorMonitorDailyItem = _resolveComponent("FridgeDoorMonitorDailyItem")
  const _component_HorizontalPaging = _resolveComponent("HorizontalPaging")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.dateList.length>0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_FridgeDetailsSelectDateBar, {
            key: _ctx.selectIndex,
            dateList: _ctx.dateList,
            type: _ctx.dateType,
            selectIndex: _ctx.selectIndex,
            isDisableButtonHidden: _ctx.isDisableButtonHidden,
            onOnSelect: _ctx.selectedDateIndex
          }, null, 8, ["dateList", "type", "selectIndex", "isDisableButtonHidden", "onOnSelect"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.list.length>0)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_HorizontalPaging, {
            class: "fridgedoormonitor-daily-content-content",
            currentPageIndex: _ctx.selectIndex,
            initialPageIndex: _ctx.initialIndex,
            onOnSelect: _ctx.selectPage
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (info) => {
                return (_openBlock(), _createBlock(_component_FridgeDoorMonitorDailyItem, {
                  class: "fridgedoormonitor-daily-content-content-item",
                  key: info.date,
                  list: info.door_open_list_time,
                  onClickCaution: _ctx.clickCaution
                }, null, 8, ["list", "onClickCaution"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1
          }, 8, ["currentPageIndex", "initialPageIndex", "onOnSelect"])
        ]))
      : _createCommentVNode("", true)
  ]))
})